import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import {
  InitialParams,
  StandardParams,
  UsePaginatedEndpointResult,
} from 'hooks/usePaginatedEndpoint/types';

import { bansApi } from './api';
import {
  BanQueryParams,
  BanSortKey,
  UserBan,
  UserBansResponseData,
} from './types';

type Params = StandardParams<BanSortKey> & BanQueryParams;

export type UserBansEndpointResult = UsePaginatedEndpointResult<
  UserBan,
  BanSortKey,
  Params
>;

export const useUserBans = (
  initialParams: InitialParams<BanSortKey, Params>,
): UserBansEndpointResult =>
  usePaginatedEndpoint<
    UserBan,
    UserBansResponseData<UserBan>,
    BanSortKey,
    Params
  >({
    endpoint: bansApi.getUserBans,
    itemsSelector: ({ bans }) => bans,
    totalSelector: ({ number_of_bans }) => number_of_bans,
    initialParams,
  });
